import { FC } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import { SubscriptionStatus } from 'app/store/Subscriptions/Subscriptions.types';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { BillingSubscriptionsActions } from 'app/store/BillingSubscriptions/BillingSubscriptions.slice';
// Selectors
import { selectFilter } from 'app/store/BillingSubscriptions/BillingSubscriptions.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import { Autocomplete } from 'app/components/Mui/Autocompletes';

const SubscriptionsFilter:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const filter = useAppSelector(selectFilter);

  const handleChange = (field:keyof typeof filter) => (newValue:unknown) => {
    dispatch(BillingSubscriptionsActions.setFilter({ [field]: newValue as SubscriptionStatus[] }));
  }

  return (
    <Box sx={{ display: 'flex', gap: 4, mb: 4, justifyContent: 'flex-end' }}>
      <Autocomplete
        value={filter.statuses}
        onChange={handleChange('statuses')}
        options={[
          { value: SubscriptionStatus.Active, label: t('labels.active') },
          { value: SubscriptionStatus.Trialing, label: t('labels.trialing') },
          { value: SubscriptionStatus.Cancelled, label: t('labels.cancelled') },
        ]}
        TextFieldProps={{
          label: t('labels.status'),
          name: 'status',
          size: 'small',
          margin: 'none'
        }}
        multiple={true}
      />
    </Box>
  )
}

export default SubscriptionsFilter;